import { Ref } from 'react';
import styles from './StanTextArea.module.css';
import { StanTextAreaProps } from '../types';
import { cn } from '@/lib';

interface StanTextAreaPropsWithRef extends StanTextAreaProps {
    ref?: Ref<HTMLTextAreaElement>;
}

export const StanTextArea = ({
    id,
    label,
    hintText,
    name,
    placeholder,
    value,
    rows = 5,
    disabled = false,
    error = false,
    className = '',
    maxLength,
    onChange,
    onFocus,
    onBlur,
    ref,
}: StanTextAreaPropsWithRef) => {
    return (
        <div className={cn('stan-textarea', styles.container)}>
            {label && <label className={styles.label}>{label}</label>}
            <div className={styles.wrapper}>
                <textarea
                    ref={ref}
                    id={id}
                    placeholder={placeholder}
                    name={name}
                    value={value}
                    disabled={disabled}
                    rows={rows}
                    maxLength={maxLength}
                    onChange={onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    className={cn(styles.textarea, error && styles.error, className)}
                />
            </div>
            {hintText && <span className={styles.hint + (error ? ` ${styles.error}` : '')}>{hintText}</span>}
        </div>
    );
};

StanTextArea.displayName = 'StanTextArea';
